import _slicedToArray from "D:/BuildAgent02/work/3584ffa7ff58f781/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _objectWithoutProperties from "D:/BuildAgent02/work/3584ffa7ff58f781/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _classCallCheck from "D:/BuildAgent02/work/3584ffa7ff58f781/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "D:/BuildAgent02/work/3584ffa7ff58f781/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _possibleConstructorReturn from "D:/BuildAgent02/work/3584ffa7ff58f781/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _get from "D:/BuildAgent02/work/3584ffa7ff58f781/node_modules/@babel/runtime/helpers/esm/get.js";
import _getPrototypeOf from "D:/BuildAgent02/work/3584ffa7ff58f781/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _inherits from "D:/BuildAgent02/work/3584ffa7ff58f781/node_modules/@babel/runtime/helpers/esm/inherits.js";
var _excluded = ["to", "from", "maxLength", "autofix"];
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import ChangeDetails from '../core/change-details.js';
import IMask from '../core/holder.js';
import MaskedPattern from './pattern.js';
import '../core/utils.js';
import './base.js';
import '../core/continuous-tail-details.js';
import './factory.js';
import './pattern/chunk-tail-details.js';
import './pattern/cursor.js';
import './pattern/fixed-definition.js';
import './pattern/input-definition.js';
import './regexp.js';

/** Pattern which accepts ranges */
var MaskedRange = /*#__PURE__*/function (_MaskedPattern) {
  _inherits(MaskedRange, _MaskedPattern);
  function MaskedRange(opts) {
    _classCallCheck(this, MaskedRange);
    return _callSuper(this, MaskedRange, [opts]); // mask will be created in _update
  }
  _createClass(MaskedRange, [{
    key: "_matchFrom",
    get:
    /**
      Optionally sets max length of pattern.
      Used when pattern length is longer then `to` param length. Pads zeros at start in this case.
    */

    /** Min bound */

    /** Max bound */

    function get() {
      return this.maxLength - String(this.from).length;
    }
  }, {
    key: "updateOptions",
    value: function updateOptions(opts) {
      _get(_getPrototypeOf(MaskedRange.prototype), "updateOptions", this).call(this, opts);
    }
  }, {
    key: "_update",
    value: function _update(opts) {
      var _opts$to = opts.to,
        to = _opts$to === void 0 ? this.to || 0 : _opts$to,
        _opts$from = opts.from,
        from = _opts$from === void 0 ? this.from || 0 : _opts$from,
        _opts$maxLength = opts.maxLength,
        maxLength = _opts$maxLength === void 0 ? this.maxLength || 0 : _opts$maxLength,
        _opts$autofix = opts.autofix,
        autofix = _opts$autofix === void 0 ? this.autofix : _opts$autofix,
        patternOpts = _objectWithoutProperties(opts, _excluded);
      this.to = to;
      this.from = from;
      this.maxLength = Math.max(String(to).length, maxLength);
      this.autofix = autofix;
      var fromStr = String(this.from).padStart(this.maxLength, '0');
      var toStr = String(this.to).padStart(this.maxLength, '0');
      var sameCharsCount = 0;
      while (sameCharsCount < toStr.length && toStr[sameCharsCount] === fromStr[sameCharsCount]) ++sameCharsCount;
      patternOpts.mask = toStr.slice(0, sameCharsCount).replace(/0/g, '\\0') + '0'.repeat(this.maxLength - sameCharsCount);
      _get(_getPrototypeOf(MaskedRange.prototype), "_update", this).call(this, patternOpts);
    }
  }, {
    key: "isComplete",
    get: function get() {
      return _get(_getPrototypeOf(MaskedRange.prototype), "isComplete", this) && Boolean(this.value);
    }
  }, {
    key: "boundaries",
    value: function boundaries(str) {
      var minstr = '';
      var maxstr = '';
      var _ref = str.match(/^(\D*)(\d*)(\D*)/) || [],
        _ref2 = _slicedToArray(_ref, 3),
        placeholder = _ref2[1],
        num = _ref2[2];
      if (num) {
        minstr = '0'.repeat(placeholder.length) + num;
        maxstr = '9'.repeat(placeholder.length) + num;
      }
      minstr = minstr.padEnd(this.maxLength, '0');
      maxstr = maxstr.padEnd(this.maxLength, '9');
      return [minstr, maxstr];
    }
  }, {
    key: "doPrepareChar",
    value: function doPrepareChar(ch, flags) {
      if (flags === void 0) {
        flags = {};
      }
      var details;
      var _get$call = _get(_getPrototypeOf(MaskedRange.prototype), "doPrepareChar", this).call(this, ch.replace(/\D/g, ''), flags);
      var _get$call2 = _slicedToArray(_get$call, 2);
      ch = _get$call2[0];
      details = _get$call2[1];
      if (!ch) details.skip = !this.isComplete;
      return [ch, details];
    }
  }, {
    key: "_appendCharRaw",
    value: function _appendCharRaw(ch, flags) {
      if (flags === void 0) {
        flags = {};
      }
      if (!this.autofix || this.value.length + 1 > this.maxLength) return _get(_getPrototypeOf(MaskedRange.prototype), "_appendCharRaw", this).call(this, ch, flags);
      var fromStr = String(this.from).padStart(this.maxLength, '0');
      var toStr = String(this.to).padStart(this.maxLength, '0');
      var _this$boundaries = this.boundaries(this.value + ch),
        _this$boundaries2 = _slicedToArray(_this$boundaries, 2),
        minstr = _this$boundaries2[0],
        maxstr = _this$boundaries2[1];
      if (Number(maxstr) < this.from) return _get(_getPrototypeOf(MaskedRange.prototype), "_appendCharRaw", this).call(this, fromStr[this.value.length], flags);
      if (Number(minstr) > this.to) {
        if (!flags.tail && this.autofix === 'pad' && this.value.length + 1 < this.maxLength) {
          return _get(_getPrototypeOf(MaskedRange.prototype), "_appendCharRaw", this).call(this, fromStr[this.value.length], flags).aggregate(this._appendCharRaw(ch, flags));
        }
        return _get(_getPrototypeOf(MaskedRange.prototype), "_appendCharRaw", this).call(this, toStr[this.value.length], flags);
      }
      return _get(_getPrototypeOf(MaskedRange.prototype), "_appendCharRaw", this).call(this, ch, flags);
    }
  }, {
    key: "doValidate",
    value: function doValidate(flags) {
      var str = this.value;
      var firstNonZero = str.search(/[^0]/);
      if (firstNonZero === -1 && str.length <= this._matchFrom) return true;
      var _this$boundaries3 = this.boundaries(str),
        _this$boundaries4 = _slicedToArray(_this$boundaries3, 2),
        minstr = _this$boundaries4[0],
        maxstr = _this$boundaries4[1];
      return this.from <= Number(maxstr) && Number(minstr) <= this.to && _get(_getPrototypeOf(MaskedRange.prototype), "doValidate", this).call(this, flags);
    }
  }, {
    key: "pad",
    value: function pad(flags) {
      var _this = this;
      var details = new ChangeDetails();
      if (this.value.length === this.maxLength) return details;
      var value = this.value;
      var padLength = this.maxLength - this.value.length;
      if (padLength) {
        this.reset();
        for (var i = 0; i < padLength; ++i) {
          details.aggregate(_get(_getPrototypeOf(MaskedRange.prototype), "_appendCharRaw", this).call(this, '0', flags));
        }

        // append tail
        value.split('').forEach(function (ch) {
          return _this._appendCharRaw(ch);
        });
      }
      return details;
    }
  }]);
  return MaskedRange;
}(MaskedPattern);
IMask.MaskedRange = MaskedRange;
export { MaskedRange as default };